var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Pie chart preview",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 180,
    r: 110,
    fill: "#ECEFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 180 L320 70 A110 110 0 0 1 431.65 156.73 Z",
    fill: "#FF7043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 180 L431.65 156.73 A110 110 0 0 1 354.33 286.18 Z",
    fill: "#42A5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320 180 L354.33 286.18 A110 110 0 0 1 219.49 234.53 Z",
    fill: "#66BB6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320 180 L219.49 234.53 A110 110 0 0 1 251.4 92.63 Z",
    fill: "#AB47BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320 180 L251.4 92.63 A110 110 0 0 1 320 70 Z",
    fill: "#FFD54F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.575a3115012abd9cf8371a5b21c3ce3a.svg";
export { ForwardRef as ReactComponent };